<!-- eslint-disable -->
<template lang="pug">
    div
        .user-form__container
            .user-form(v-if="authUser")
                .user-form__title
                    slot(name="title")
                form.user-form__body(
                    v-if="user.status === 'active'"
                    action="javascript://"
                    @submit="submitForm"
                )
                    .user-form__field(v-if="!userCopy.isManagerOrSupport")
                        .user-form__label
                            | {{ $i18n.t('user.user_form_lastName') }}
                        .user-form__field-body
                            cs-input.user-form__input(
                                :error="errors.has('lastName')"
                                type="text"
                                v-model="userCopy.lastName"
                                name="lastName"
                                v-validate="'required'"
                                :data-vv-as="$i18n.t('user.user_form_lastNameDataVvSs')"
                            )
                            help-text(v-if="errors.has('lastName')" :error="errors.has('lastName')")
                                | {{ errors.first('lastName')}}
                    .user-form__field(v-if="!userCopy.isManagerOrSupport")
                        .user-form__label
                            | {{ $i18n.t('user.user_form_firstName') }}
                        .user-form__field-body
                            cs-input.user-form__input(
                                :error="errors.has('firstName')"
                                type="text"
                                v-model="userCopy.firstName"
                                name="firstName"
                                v-validate="'required'"
                                :data-vv-as="$i18n.t('user.user_form_firstNameDataVvSs')"
                            )
                            help-text(v-if="errors.has('firstName')" :error="errors.has('firstName')")
                                | {{ errors.first('firstName')}}
                    .user-form__field(v-if="!userCopy.isManagerOrSupport")
                        .user-form__label
                            | {{ $i18n.t('user.user_form_gender') }}
                        .user-form__field-body
                            cs-multiselect(
                                :multiple="false"
                                :options="sex"
                                :show-labels="false"
                                :allow-empty="false"
                                :custom-label="getSex"
                                placeholder=""
                                v-model="userCopy.sex"
                                :searchable="false"
                            )
                    .user-form__field(v-if="!userCopy.isManagerOrSupport")
                        .user-form__label
                            | {{ $i18n.t('user.user_form_birthdayDate') }}
                        .user-form__field-body
                            cs-datepicker(
                                initial-view="year"
                                :language="authUser.locale"
                                :error="errors.has('birthDate')"
                                name="birthDate"
                                :format="customFormatter"
                                v-validate="'required'"
                                :value="userCopy.birthday"
                                @input="userCopy.birthday = dateToMoment($event, 'YYYY-MM-DD')"
                                :data-vv-as="$i18n.t('user.user_form_birthdayDateLowerCase')"
                            )
                            help-text(v-if="errors.has('birthDate')" :error="errors.has('birthDate')")
                                | {{ errors.first('birthDate')}}
                    divider
                    .user-form__field(v-if="type === 'admin' && (authUser.isSuperadmin || authUser.isManagerOrSupport)")
                        .user-form__label
                            | {{ $i18n.t('common.common_navigation_telegram_verification_onOff') }}
                        .user-form__field-body
                            cs-checkbox(:checked='!!userCopy.telegramVerified' @change="handleChangeTelegramField($event, 'telegramVerified')")
                    .user-form__field(v-if="type === 'admin' && (authUser.isSuperadmin || authUser.isManagerOrSupport)")
                        .user-form__label
                            | {{ $i18n.t('telegram.telegram_label') }}
                        .user-form__field-body
                            telegram-login-widget(
                                bot-username="cs_test4444_bot"
                                :verified="userCopy.telegramVerified"
                                @verified="onTelegramVerified"
                            )
                    divider(v-if="type === 'admin' && (authUser.isSuperadmin || authUser.isManagerOrSupport)")
                    .user-form__field(v-if="type === 'admin' && (authUser.isSuperadmin || authUser.isManagerOrSupport)")
                        .user-form__label
                            | {{ $i18n.t('max.max_verification_onOff') }}
                        .user-form__field-body
                            cs-checkbox(:checked='!!userCopy.maxVerified' @change="handleChangeTelegramField($event, 'maxVerified')")
                    .user-form__field(v-if="type === 'admin' && (authUser.isSuperadmin || authUser.isManagerOrSupport)")
                        .user-form__label
                            | {{ $i18n.t('max.max_label') }}
                        .user-form__field-body
                            max-login-widget(
                                :verified="userCopy.maxVerified"
                                :adminId="userCopy.id"
                                @verified="onMaxVerified"
                            )
                    divider
                    .user-form__field(v-if="!userCopy.isManagerOrSupport")
                        .user-form__label
                            | {{ $i18n.t('user.user_form_language') }}
                        .user-form__field-body
                            cs-multiselect(
                                :multiple="false"
                                :options="locales"
                                :show-labels="false"
                                :allow-empty="false"
                                :custom-label="getLocaleName"
                                placeholder=""
                                v-model="userCopy.locale"
                                :searchable="false"
                                v-validate="'required'"
                                name="locale"
                                :data-vv-as="$i18n.t('user.user_form_languageDataVvSs')"
                            )
                            help-text(v-if="errors.has('locale')" :error="errors.has('locale')")
                                | {{ errors.first('locale')}}
                    .user-form__field(v-if="isMainContactInSomeSchool")
                        .user-form__label
                            | {{ $i18n.t('profiles.profiles_profile_referralCode') }}
                        .user-form__field-body(v-if="user.referralCode")
                            | {{ user.referralCode }}
                        .user-form__field-body(v-else)
                            | Is not defined
                    .user-form__field(v-if="type !== 'admin' && (authUser.isSuperadmin || authUser.type === 'admin')")
                        .user-form__label
                            | {{ $i18n.t('user.user_form_archivedDate') }}
                        .user-form__field-body
                            cs-datepicker(
                                :language="authUser.locale"
                                :disabled-dates="{ to: yesterday }"
                                :format="customFormatter"
                                :value="userCopy.archivingDate"
                                @input="userCopy.archivingDate = dateToMoment($event, 'YYYY-MM-DD')"
                            )
                    divider(v-if="!userCopy.isManagerOrSupport")
                    .user-form__field(v-if="showContactInfo")
                        .user-form__label
                            | {{ $i18n.t('user.user_form_email') }}
                        .user-form__field-body
                            cs-input.user-form__input(
                                :error="errors.has('email')"
                                type="email"
                                v-model="userCopy.email"
                                name="email"
                                v-validate="'required'"
                                :data-vv-as="$i18n.t('user.user_form_emailDataVvSs')"
                            )
                            help-text(v-if="errors.has('email')" :error="errors.has('email')")
                                | {{ errors.first('email')}}
                    .user-form__field
                        .user-form__label
                            | {{ $i18n.t('user.user_form_login') }}
                        .user-form__field-body
                            cs-input.user-form__input(
                                :error="errors.has('username')"
                                type="text"
                                v-model="userCopy.username"
                                name="username"
                                v-validate="'required'"
                                :data-vv-as="$i18n.t('user.user_form_loginDataVvSs')"
                            )
                            help-text(v-if="errors.has('username')" :error="errors.has('username')")
                                | {{ errors.first('username')}}
                    .user-form__field(v-if="!userCopy.isManagerOrSupport && showContactInfo")
                        .user-form__label
                            | {{ $i18n.t('user.user_form_phone') }}
                        .user-form__field-body
                            cs-input.user-form__input(
                                type="tel"
                                v-model="userCopy.phone"
                            )
                    divider(v-if="!userCopy.isManagerOrSupport")
                    .user-form__field
                        .user-form__label.user-form__label--image
                            | {{ $i18n.t('user.user_form_image') }}
                        .user-form__field-body
                            cs-image-input(
                                v-model="userCopy.avatar"
                                type="user"
                                @showSizeError="showSizeError"
                                :loadText="$i18n.t('profiles.profiles_common_uploadImage')"
                                :removeText="$i18n.t('profiles.profiles_common_removeImage')"
                                :helpText="$i18n.t('common.common_imageInput_sizeHelpText')"
                                :error="showImageWarning ? imageWarningText : ''"
                            )
                    divider(v-if="!userCopy.isManagerOrSupport")
                    .user-form__field
                        .user-form__label
                            | {{ $i18n.t('user.user_form_password') }}
                        .user-form__field-body
                            cs-input.user-form__input(
                                :error="errors.has('password')"
                                type="password"
                                v-model="userCopy.password"
                                name="password"
                                v-validate="passwordValidationRule"
                                :data-vv-as="$i18n.t('user.user_form_passwordDataVvSs')"
                            )
                            help-text(v-if="errors.has('password')" :error="errors.has('password')")
                                | {{ errors.first('password')}}
                    .user-form__field
                        .user-form__label
                            | {{ $i18n.t('user.user_form_confirmPassword') }}
                        .user-form__field-body
                            cs-input.user-form__input(
                                :error="errors.has('password_confirmation')"
                                type="password"
                                v-model="userCopy.passwordConfirmation"
                                v-validate="'min:6'"
                                name="password_confirmation"
                                :data-vv-as="$i18n.t('user.user_form_confirmPasswordDataVvSs')"
                            )
                            help-text(v-if="errors.has('password_confirmation')" :error="errors.has('password_confirmation')")
                                | {{ errors.first('password_confirmation')}}
                    template(v-if="isSchoolAvailable && !userCopy.isManagerOrSupport")
                        divider
                        .user-form__field
                            .user-form__label
                                | {{ $i18n.tc('user.user_form_school', 1) }}
                            .user-form__field-body
                                cs-multiselect(
                                    v-if="type !== 'student'"
                                    :multiple="true"
                                    :options="schools"
                                    :show-labels="false"
                                    label="name"
                                    track-by="id"
                                    :searchable="true"
                                    :loading="loadingSchools"
                                    @open="getSchools"
                                    :placeholder="$i18n.t('common.common_placeholder_enterToSearch')"
                                    v-model="userCopy.schools"
                                    :allow-empty="false"
                                )
                                    span(slot="noResult")
                                        | {{ $i18n.t('user.user_form_noResult') }}
                                cs-multiselect(
                                    v-else
                                    :multiple="true"
                                    :options="schools"
                                    :show-labels="false"
                                    label="name"
                                    track-by="id"
                                    :searchable="true"
                                    :loading="loadingSchools"
                                    @open="getSchools"
                                    :placeholder="$i18n.t('common.common_placeholder_enterToSearch')"
                                    v-model="userCopy.schools"
                                    :allow-empty="false"
                                )
                                    span(slot="noResult")
                                        | {{ $i18n.t('user.user_form_noResult') }}
                                help-text(v-if="errors.has('school')" :error="errors.has('school')")
                                    | {{ errors.first('school')}}
                    .user-form__field(
                        v-if="type !== 'admin' && !userCopy.isManagerOrSupport && (authUser.isSuperadmin || authUser.type === 'admin' || authUser.isManagerOrSupport)"
                    )
                        .user-form__label
                            | {{ $i18n.tc('user.user_form_grade', 1) }}
                        .user-form__field-body(v-if="grades")
                            template(v-if="userCopy.type === 'student'")
                                cs-multiselect(
                                    :multiple="true"
                                    :options="grades"
                                    :show-labels="false"
                                    :hide-selected="false"
                                    label="name"
                                    track-by="id"
                                    :searchable="true"
                                    :loading="loadingGrades"
                                    :placeholder="grades.length ? $i18n.t('user.user_form_gradePlaceholder') : ''"
                                    :disabled="grades.length === 0"
                                    v-model="userCopy.grades"
                                    :allow-empty="false"
                                )
                                    span(slot="noResult")
                                        | {{ $i18n.t('user.user_form_gradeNoResult') }}
                                help-text(v-if="errors.has('grade')" :error="errors.has('grade')")
                                    | {{ errors.first('grade')}}
                                p.help(v-show="grades.length === 0" class="help")
                                    | {{ $i18n.t('user.user_form_gradeNoExist') }}
                            template(v-else)
                                cs-multiselect(
                                    :options="grades"
                                    :show-labels="false"
                                    :hide-selected="true"
                                    label="name"
                                    track-by="id"
                                    :loading="loadingGrades"
                                    :placeholder="grades.length ? $i18n.t('user.user_form_gradePlaceholder') : ''"
                                    v-model="userCopy.grades"
                                    :disabled="grades.length === 0"
                                    class="multiple-multiselect"
                                    name="grade"
                                    :data-vv-as="$i18n.t('user.user_form_gradeDataVvSs')"
                                    allow-empty
                                )
                                    span(slot="noResult")
                                        | {{ $i18n.t('user.user_form_gradeNoResult') }}
                                help-text(v-if="errors.has('grade')" :error="errors.has('grade')")
                                    | {{ errors.first('grade')}}
                    divider(v-if="!userCopy.isManagerOrSupport")
                    .user-form__field(v-if="!userCopy.isManagerOrSupport")
                        .user-form__label
                            | {{ $i18n.t('user.user_form_city') }}
                        .user-form__field-body
                            cs-input.user-form__input(
                                :error="errors.has('city')"
                                type="text"
                                v-model="userCopy.city"
                                v-validate="'required'"
                                name="city"
                                :data-vv-as="$i18n.t('user.user_form_cityDataVvSs')"
                            )
                            help-text(v-if="errors.has('city')" :error="errors.has('city')")
                                | {{ errors.first('city')}}
                    .user-form__field(v-if="!userCopy.isManagerOrSupport")
                        .user-form__label
                            | {{ $i18n.t('user.user_form_address') }}
                        .user-form__field-body
                            cs-input.user-form__input(
                                :error="errors.has('address')"
                                type="text"
                                v-model="userCopy.address"
                                v-validate="'required'"
                                name="address"
                                :data-vv-as="$i18n.t('user.user_form_addressDataVvSs')"
                            )
                            help-text(v-if="errors.has('address')" :error="errors.has('address')")
                                | {{ errors.first('address')}}
                    template(v-if="userCopy.parents && userCopy.type === 'student'")
                        divider
                        template(v-for="parent in userCopy.parents")
                            .user-form__field
                                .user-form__label
                                .user-form__field-body.user-form__field-body--bold
                                    | {{ $i18n.t('user.user_form_parent') }}
                            .user-form__field
                                .user-form__label
                                    | {{ $i18n.t('user.user_form_lastName') }}
                                .user-form__field-body
                                    cs-input.user-form__input(
                                        type="text"
                                        v-model="parent.lastName"
                                    )
                            .user-form__field
                                .user-form__label
                                    | {{ $i18n.t('user.user_form_firstName') }}
                                .user-form__field-body
                                    cs-input.user-form__input(
                                        type="text"
                                        v-model="parent.firstName"
                                    )
                            .user-form__field
                                .user-form__label
                                    | {{ $i18n.t('user.user_form_email') }}
                                .user-form__field-body
                                    cs-input.user-form__input(
                                        type="email"
                                        v-model="parent.email"
                                    )
                            .user-form__field
                                .user-form__label
                                    | {{ $i18n.t('user.user_form_phone') }}
                                .user-form__field-body
                                    cs-input.user-form__input(
                                        type="tel"
                                        v-model="parent.phone"
                                    )
                    .user-form__buttons
                        cs-button.user-form__button(
                            color="blue"
                            pattern="primary-outline"
                            @click.prevent="$router.back()"
                        )
                            | {{ $i18n.t('common.common_button_cancel') }}
                        cs-button.user-form__button(
                            color="blue"
                            type="submit"
                            :loading="isLoading"
                            :disabled="isLoading"
                        )
                            slot(name="button")
                div(v-else) {{ $i18n.t('user.user_form_unableToEdit') }}

        cs-modal(v-if="priceModal.show" is-blur @close="closePriceModal")
            .price-modal-text(
                v-html="$i18n.t('user.user_form_withdrawal_of_money', { payment: '<b>' + priceModal.price + ' ' + $i18n.tc('olympiads.olympiads_olympiadForm_rubles', priceModal.price) + '</b>' })"
            )
            .price-modal-buttons
                cs-button(color="orange" @click="closePriceModal")
                    | {{ $i18n.t('user.user_form_cancel') }}
                cs-button(@click="runSubmit")
                    | {{ $i18n.t('user.user_form_confirm') }}
</template>

<script>
    /*eslint-disable*/
    import _ from 'lodash';
    import GradeApi from '../../api/grade'
    import SchoolApi from '../../api/school'
    import UserApi from '../../api/user/user'
    import PaymentServicesApi from '../../api/billing/paymentServices';
    import {mapState} from 'vuex';
    import moment from 'moment';
    import availableLocales from "../../config/availableLocales";
    import HelpText from '../../elements/HelpText.vue';
    import TelegramLoginWidget from '../../elements/TelegramLoginWidget.vue';
    import MaxLoginWidget from '../../elements/MaxLoginWidget.vue';
    import Cookies from 'js-cookie';
    import {TEACHER_TOKEN as TEACHER_TOKEN} from "../../config/cookies";

    const USER_TYPES_NOT_ALLOWED_TO_HAVE_MORE_THAN_ONE_SCHOOL = ['student', 'teacher'];
    export default {
        components: {HelpText, TelegramLoginWidget, MaxLoginWidget},
        props: {
            user: Object,
            type: String,
            submit: Function,
            isPasswordRequired: {
                type: Boolean,
                default: false
            },
            notEnoughMoneyOnAccount: {
                type: Boolean,
                default: false,
            },
        },
        data() {
            return {
                grades: [],
                userCopy: null,
                paymentServices: [],
                statuses: [
                    'active',
                    'archived'
                ],
                statusNames: {
                    active: this.$i18n.t('user.user_form_statusNameActive'),
                    archived: this.$i18n.t('user.user_form_statusNameArchived')
                },
                sex: [
                    'male',
                    'female'
                ],
                sexNames: {
                    male: this.$i18n.t('user.user_form_genderMale'),
                    female: this.$i18n.t('user.user_form_genderFemale')
                },
                locales: availableLocales.locales,
                localeNames: availableLocales.localeNames,
                schools: [],
                isLoading: false,
                loadingSchools: false,
                loadingGrades: false,
                loadingCourse: false,
                loadingPaymentServices: false,
                image: null,
                currentDate: null,
                imageWarningText: '',
                showImageWarning: false,
                showBalanceModal: false,
                priceModal: {
                    show: false,
                    price: 0,
                },
                submitParams: null,
            }
        },
        created() {
            this.$moment.locale(this.$i18n.locale);
            if (!this.user.id && this.type === 'admin') {
                delete this.user.grades;
                delete this.user.school;
                delete this.user.schools;
            }
            this.userCopy = _.cloneDeep(this.user);
            let momentBirthday = this.$moment(this.userCopy.birthday);
            this.$set(this.userCopy, 'date', {
                day: momentBirthday.format('DD'),
                month: momentBirthday.format('MM'),
                year: momentBirthday.format('YYYY'),
            });
            if (this.userCopy.courses) {
                this.courses = [...this.userCopy.courses];
            }
            if (window.localStorage.getItem('userModel')) {
                this.userCopy = _.cloneDeep(JSON.parse(window.localStorage.getItem('userModel')));
                window.localStorage.removeItem('userModel');
            }
            this.currentDate = moment();
        },
        watch: {
            notEnoughMoneyOnAccount (value) {
                this.showBalanceModal = value;
            },
            'user.school': {
                handler(newSchool) {
                    this.userCopy.school = _.cloneDeep(newSchool);
                },
            },
            'userCopy.school': {
                handler(val, oldVal) {
                    if (oldVal && val && val.id !== oldVal.id) {
                        this.userCopy.grades = [];
                        // this.type === 'student' && (this.userCopy.grade = null);
                        this.getGrades();
                    } else if (val) {
                        this.getGrades();
                    } else if (val === null) {
                        this.userCopy.grades = [];
                        this.userCopy.school = null;
                        // this.type === 'student' && (this.userCopy.grade = null);
                        this.grades = [];
                        this.schools = [];
                    }
                },
                deep: true
            },
            'userCopy.schools': {
                handler (schools, oldSchools) {
                    this.userCopy.school = schools && _.cloneDeep(schools[0]);
                    if (!oldSchools) {
                        this.getGrades();
                    } else if (schools && schools.length) {
                        let schoolsIds = schools.map(school => school.id);
                        this.userCopy.grades = this.userCopy.grades.filter(grade => schoolsIds.includes(grade.schoolId));
                        this.grades = [];
                        this.getGrades();
                    } else if (oldSchools) {
                        this.userCopy.grades = [];
                        this.grades = [];
                    }
                },
                deep: true
            },
            'userCopy.grade': {
                handler (val) {
                    val && (this.userCopy.grades[0] = val);
                }
            },
            'userCopy.avatar': {
                handler (val) {
                    if (val) {
                        this.showImageWarning = false;
                        this.imageWarningText = '';
                    }
                }
            },
        },
        methods: {
            dateToMoment (date, format) {
                return moment(date).format(format);
            },
            asyncFindExistSchool(name) {
                this.loadingGrades = true;
                SchoolApi.list({
                    name: name
                }).then((data) => {
                    this.$set(this, 'grades', data.data[0].grades || []);
                    this.loadingGrades = false;
                }).catch(err => {
                    this.loadingGrades = false;
                    this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                });
            },
            getStatusName(status) {
                return this.statusNames[status];
            },
            getSex(sex) {
                return this.sexNames[sex];
            },
            getLocaleName(locale) {
                return this.localeNames[locale];
            },
            closePriceModal() {
                this.priceModal.show = false;
                this.priceModal.price = 0;
            },
            async submitForm() {
                const isPassedValidation = await this.$validator.validateAll();
                if (!isPassedValidation) return;
                if (this.user.referralCode === this.userCopy.referralCode) {
                    this.userCopy.referralCode = '';
                }
                let params = _.cloneDeep(this.userCopy);
                if(
                    USER_TYPES_NOT_ALLOWED_TO_HAVE_MORE_THAN_ONE_SCHOOL.includes(params.type)
                    && params.schools.length > 1
                ) {
                    this.$toasted.error(this.$root.$t('user.user_form_schoolError'));
                    return;
                }
                if (params.type === 'student' && !params.grades.length) {
                    this.$toasted.error(this.$root.$t('user.user_form_gradeError'));
                    return;
                }

                if (this.authUser.type === 'student' || this.authUser.type === 'teacher') {
                    delete params.school;
                    delete params.schools;
                    delete params.grades;
                    delete params.transactions;
                    delete params.courses;
                } else if (params.type === 'student') {
                    let schoolsIdsInGrades = params.grades.map(grade => grade.schoolId);
                    if (!params.schools.map(school => school.id).every(id => schoolsIdsInGrades.includes(id))) {
                        this.$toasted.error(this.$i18n.t('user.user_form_gradeSchoolError'));
                        return;
                    }
                }
                if (!params.isSuperadmin && !params.isManagerOrSupport && params.schools && params.grades) {
                    params.schools = params.schools.map(school => school.id);
                    params.grades = params.grades.map(grade => grade.id);
                }

                if (params.account) {
                    params.account.paymentService = params.account.paymentService.id;
                }

                if (params.type === 'admin' && params.schools && !params.schools.length) {
                    delete params.schools;
                }

                this.submitParams = params;

                if (
                    (this.authUser.type !== 'student' && this.userCopy.type === 'student') ||
                    (this.authUser.type !== 'teacher' && this.userCopy.type === 'teacher')
                ) {
                    const isChangedSchool = params.schoolsIds && params.schools[0] !== params.schoolsIds[0];
                    if(isChangedSchool) { 
                        return this.runSubmit();
                    }
                    const price = await UserApi.getPriceForUpdate({ 
                        id: params.id, 
                        type: params.type,
                        status: params.status,
                        schoolId: params.schools[0], 
                        grades: params.grades, 
                    });
                    this.priceModal.show = true;
                    this.priceModal.price = price;
                } else {
                    this.runSubmit();
                }
            },
            async runSubmit() {
                this.closePriceModal();
                this.isLoading = true;
                try {
                    await this.submit(this.submitParams);
                    if(this.authUser.id === this.userCopy.id && this.userCopy.avatar) {
                        this.$store.dispatch('setAuthUserAvatar', this.userCopy.avatar);
                    }
                } catch(err) {
                    if (err && err.response && err.response.data.errors) {
                        let errors = err.response.data.errors;
                        for (let field in errors) {
                            if (errors.hasOwnProperty(field)) {
                                errors[field].forEach((val) => {
                                    this.errors.add(field, val);
                                });
                            }
                        }
                    }
                } finally {
                    this.isLoading = false;
                }
            },
            getSchools () {
                if (this.schools.length) {
                    return;
                }
                this.loadingSchools = true;
                let params = { all: true };
                if (!this.authUser.isSuperadmin || this.userCopy.type === 'student') {
                    Object.assign(params, { withActiveAccount: true });
                }
                if (this.userCopy.type === 'teacher') {
                    Object.assign(params, { withActiveAccount: false });
                }
                SchoolApi.list(params).then((data) => {
                    let schools = data.schools;
                    this.schools = schools ? schools : [];
                    this.schools = this.schools.filter(school => {
                        return school.account.status || !school.account.status && !school.isTeachersBillingActive
                    });
                    this.loadingSchools = false;
                }).catch(err => {
                    this.loadingSchools = false;
                    this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                });
            },
            getGrades () {
                if (this.userCopy.school || this.userCopy.schools) {
                    GradeApi.list({
                        schoolId: this.userCopy.school?.id,
                        schoolsIds: this.userCopy.schools?.map(school => school.id),
                        status: 'active',
                        all: true
                    }).then(data => {
                        let grades = data.grades;
                        this.grades = grades ? grades : [];
                        this.loadingGrades = false;
                    }).catch(err => {
                        this.loadingGrades = false;
                        this.$toasted.error(this.$root.$t('errors.error_has_occurred'));
                    });
                }
            },
            showSizeError () {
                this.imageWarningText = this.$i18n.t('trainer.trainer_gameFormSetting_imageWeightWarning');
                this.showImageWarning = true;
            },
            getPaymentServices() {
                if (this.paymentServices.length) {
                    return;
                }
                this.loadingPaymentServices = true;
                PaymentServicesApi.list()
                .then(data => {
                    this.paymentServices = data.data;
                    this.loadingPaymentServices = false;
                }).catch(err => {
                    this.loadingPaymentServices = false;
                    this.$toasted.error(this.$i18n.t('errors.error_has_occurred'));
                });
            },
            customFormatter(date) {
                return moment(date).format('D MMM YYYY');
            },
            onTelegramVerified(result) {
                if (result && result.user) {
                    this.userCopy.telegramId = result.user.telegramId;
                    this.userCopy.telegramVerified = true;
                }
            },
            onMaxVerified(result) {
                if (result && result.user) {
                    this.userCopy.maxId = result.user.maxId;
                    this.userCopy.maxVerified = true;
                }
            },
            handleChangeTelegramField(event, key) {
                this.userCopy[key] = event;
            },
        },
        computed: {
            yesterday() {
                return this.currentDate.subtract(1, 'days').toDate();
            },
            isSchoolAvailable () {
                return this.type !== 'admin'
                    && (this.authUser.isSuperadmin || this.authUser.type === 'admin' || this.authUser.isManagerOrSupport);
            },
            passwordValidationRule() {
                let rule = 'min:6|confirmed:password_confirmation';
                if (this.isPasswordRequired) {
                    rule = 'required|' + rule;
                }
                return rule;
            },
            ...mapState({
                authUser: state => state.auth.user,
            }),
            schoolWithAccount () {
                if (this.userCopy && this.userCopy.schools) {
                    return this.userCopy.schools.find(school => !school.studentPayed);
                }
                return null;
            },
            hasStudentPayedSchool () {
                if (this.userCopy.type === 'student') {
                    return this.userCopy.schools.some(school => school.studentPayed);
                }
                return false;
            },
            isMainContactInSomeSchool () {
                return this.user?.schools?.some(school => school.mainContactId === this.user.id);
            },
            showContactInfo () {
                return !((Cookies.get(TEACHER_TOKEN) && this.authUser.type === 'student')
                    || (this.authUser.type === 'teacher' && this.user.type === 'student'));
            }
        },
        filters: {
            capitalize(string) {
                return _.capitalize(string);
            }
        },
    }
</script>

<style lang="scss" scoped>
    .user-form__container {
        margin: 0;
        height: 100%;
        background-color: $x-color-white;
        border-radius: $border-radius-20;
        box-sizing: border-box;
        @include media($md) {
            padding: 30px;
        }
    }

    .user-form {
        margin: 0;
        padding: 30px 20px;
        height: 100%;
        background-color: $hsl-color-gray-98;
        border-radius: $border-radius-20;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        flex-direction: column;
        @include media($md) {
            padding: 30px;
        }
    }

    .user-form__title {
        font-weight: 500;
        font-size: 22px;
        line-height: 26px;
        margin-bottom: 25px;
    }

    .user-form__body {
        width: 100%;
        box-sizing: border-box;
        @include media($lg) {
            padding: 0 4.5%;
        }
    }

    .user-form__field {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        @include media($md) {
            padding: 0 2.5px;
            flex-direction: row;
            align-items: center;
        }
        @include media($lg) {
            padding: 0 10%;
        }
        @include media($xlg) {
            padding: 0 13%;
        }
    }

    .user-form__input {
        margin-bottom: 0;
    }

    .user-form__label {
        min-width: 0;
        font-size: 16px;
        line-height: 19px;
        margin-right: 20px;
        margin-bottom: .5rem;
        @include media($md) {
            width: 8em;
            min-width: 8em;
            margin-bottom: 0;
            text-align: right;
        }
        @include media($xlg) {
            width: 13em;
            min-width: 13em;
        }
    }

    .user-form__label--image {
        @include media($md) {
            padding-top: 2.5em;
        }
    }

    .user-form__field-body {
        flex-grow: 5;
    }

    .user-form__field-body--bold {
        font-weight: 500;
    }

    .user-form__buttons {
        margin-top: 30px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        @include media($md) {
            flex-direction: row;
        }
    }

    .user-form__button {
        margin: 10px 50px;
        @include media($md) {
            margin: 0 10px;
        }
    }

    .price-modal-text {
        margin-top: 20px;
    }

    .price-modal-buttons {
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .cs-button {
          padding: 15px 20px;
          @include media($md) {
            padding: 15px 30px;
          }
        }
    }
</style>
